// removed by extract-text-webpack-plugin
module.exports = {"small":"nrk-v17-static-small","medium":"nrk-v17-static-medium","large":"nrk-v17-static-large","xlLarge":"nrk-v17-static-xlLarge"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stylesheets/sizes.css
// module id = 234
// module chunks = 0 1 2 3 4 5 6 7 8 9